import React, { useState, useEffect } from "react";
import { ActivityIndicator, FlatList, View } from "react-native";
import { ODSText } from "../../atoms/ODSText";

import ODSRadioGroup from "../../atoms/ODSRadioGroup";
import { ODSInput } from "../../atoms/ODSInput";
import SkeletonBox from "./SkeletonBox";
import TenantCard from "./CoTenantCard";
import TenantCardSkeleton from "./TenantCardSkeleton";
import EmptyState from "./EmptyState";
import ODSButton from "../../atoms/ODSButton/index";

const JointTenantCard = ({ initialData = [], onConnect, themeObj, loading, onUnlink, loading2, data }) => {
    const [hasTlyfeId, setHasTlyfeId] = useState("");
    const [showAdd, setShowAdd] = useState(false);
    const [coTeanats, setCoTeanants] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const resetForm = () => {
        setHasTlyfeId("");
        setInputValue("");
        setShowAdd(false);
    };

    useEffect(() => {
        if (initialData && initialData?.length) {
            resetForm()
            setCoTeanants([...initialData]);
        } else {
            setCoTeanants([])
        }
    }, [initialData]);
    const handleConnect = () => {
        const payload = {
            hasTlyfeId,
            value: inputValue,
            type: hasTlyfeId === "yes" ? "tlyfeId" : "email",
        };
        onConnect && onConnect(payload);
    };
    if (loading) {
        return (
            <View>
                {[1, 2, 3].map((_, i) => (
                    <TenantCardSkeleton key={i} />
                ))}
            </View>
        );
    }
    const isValidEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/;
        return regex.test(email);
    };
    const normalizeValue = (value) => String(value || "").trim().toLowerCase();
    const isAddingSelf =
        inputValue.trim().length > 0 &&
        (hasTlyfeId === "yes"
            ? normalizeValue(inputValue) === normalizeValue(data?.appUser?.opbrix_id)
            : normalizeValue(inputValue) === normalizeValue(data?.appUser?.user?.email));
    const isInputValid =
        !isAddingSelf &&
        (hasTlyfeId === "yes"
            ? inputValue.trim().length > 0
            : isValidEmail(inputValue));
    return (
        < >
            <ODSText style={{ alignSelf: "center" }} type={"h5"}>
                Joint Tenants
            </ODSText>

            <ODSText
                color={themeObj.neutral[700]}
                marginTop={10}
                style={{ alignSelf: "center" }}
                type={"md"}
            >
                (including spouse, partner, children 18 years or over and sharers)
            </ODSText>



            <ODSButton
                rIcon={"Frame"}
                restStyle={{
                    marginBottom: 10,
                    width: 150,
                    height: 45,
                    marginTop: 16,
                    alignSelf: "flex-end",
                }}
                type="secondary"
                onPress={() => {
                    setShowAdd(true)
                }}
            >
                Add
            </ODSButton>
            {showAdd ? <View >
                <View
                    style={{
                        height: 1,
                        backgroundColor: "#E0E0E0",
                        marginVertical: 16,
                        width: "100%",
                    }}
                />
                <View style={{ flexDirection: "row" }}>
                    <ODSRadioGroup
                        width="100%"
                        label={`Joint tenant`}
                        subLable={"Does this tenant have a tlyfe ID?"}
                        checked={hasTlyfeId}
                        onChange={(val) => {
                            setHasTlyfeId(val)
                            setInputValue("")
                        }}
                    />
                </View>

                {(hasTlyfeId === "yes" || hasTlyfeId === "no") && (
                    <View style={{ marginTop: 20 }}>

                        <ODSInput
                            label={hasTlyfeId === "yes" ? "tlyfe ID" : "Email address"}
                            placeholder={hasTlyfeId === "yes" ? "tlyfe ID" : "Email address"}
                            style={{ width: '100%' }}
                            value={inputValue}
                            onChange={(val) =>
                                setInputValue(val)
                            }
                            hints={
                                inputValue === ""
                                    ? []
                                    : isAddingSelf
                                        ? [{ hint: "You can't add yourself as a co-tenant.", state: "error" }]
                                        : hasTlyfeId === "no" && !isValidEmail(inputValue)
                                            ? [{ hint: "Enter valid email", state: "error" }]
                                            : []
                            }
                        />
                        <ODSButton
                            rIcon={loading2 ? null : "TB-Edit"}
                            restStyle={{
                                marginVertical: 10,
                                width: 150,
                                height: 50,
                                alignSelf: "flex-end",
                            }}
                            disabled={!isInputValid || loading2}
                            type="primary"
                            themeColor={themeObj.main.purple}
                            onPress={handleConnect}
                        >
                            {loading2 ? <ActivityIndicator color={"white"} /> : "Connect"}
                        </ODSButton>
                    </View>
                )}
            </View> : false}
            <View
                style={{
                    height: 1,
                    backgroundColor: "#E0E0E0",
                    marginVertical: 16,
                    width: "100%",
                }}
            />
            <FlatList
                data={coTeanats}
                keyExtractor={(item) => item?.app_user_id}
                renderItem={({ item, index }) => (
                    <TenantCard
                        item={item}
                        index={index}
                        onUnlink={(data) => { onUnlink(data) }}
                    />
                )}
                ListEmptyComponent={!loading ? <EmptyState /> : null}
            />
        </>
    );
};

export default JointTenantCard;